import React from "react";
import Layout from "../component/Layout/Layout";
import { useTrackingOrderAPI } from "../hooks/useAllCategoryData";
import { Link, useNavigate, useParams } from "react-router-dom";
import { dateInMDY } from "../Helper";
export default function TrackOrder() {
  const navigate = useNavigate();
  const { order_no } = useParams();
  const {
    data: tracking,
    isLoading: loading,
    error,
    isFetching
  } = useTrackingOrderAPI(order_no);

  return (
    <Layout title="Track Order : Chaashni Couture"
    description="Chaashni Couture: Description">
      <div className="site-content-wrap static-page">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="sustom-heading-h1">
                Track <span>Order</span>
              </h1>
              {error ? navigate('/404'): (
                !isFetching &&
                <div className="content-box">
                  <div className="card mb-3">
                    <div className="p-3 text-center text-white text-lg bg-dark rounded-top">
                      <div>
                        <span className="text-uppercase">Order No - </span>
                        <span className="text-medium">#{tracking?.id}</span>
                      </div>
                    </div>
                    <div className="d-flex flex-wrap flex-sm-nowrap justify-content-between py-2 px-2 bg-secondary">
                      <div className="text-center py-1 px-2 text-capitalize">
                        <span className="text-medium">
                          <strong>Order Status: </strong>
                        </span>
                        {tracking?.order_status}
                      </div>
                      <div className="text-center py-1 px-2 text-capitalize">
                        <span className="text-medium">
                          <strong>Payment Status: </strong>
                        </span>
                        {tracking?.payment_status} (
                        {tracking?.payment_method.replace(/#|_/g, " ")})
                      </div>
                      <div className="text-center py-1 px-2 text-capitalize">
                        <span className="text-medium">
                          <strong>Order Date: </strong>
                        </span>
                        {tracking?.created_at? dateInMDY(tracking?.created_at):''}
                      </div>
                    </div>
                    {loading ? (
                      <div className="loading-div">
                        <span>Loading...</span>
                      </div>
                    ) : tracking?.order_status === "returned" ||
                      tracking?.order_status === "failed" ||
                      tracking?.order_status === "canceled" ? (
                      <div className="tracking-list text-capitalize text-center">
                        Your Order is {tracking?.order_status}
                      </div>
                    ) : (
                      <div className="tracking-list">
                        <div
                          className={`${
                            tracking?.order_status !== "returned" &&
                            tracking?.order_status !== "failed"
                              ? "tracking-item"
                              : "tracking-item-pending"
                          }`}
                        >
                          <div
                            className={`${
                              tracking?.order_status === "pending"
                                ? "tracking-icon status-current blinker"
                                : "tracking-icon status-intransit"
                            }`}
                          >
                            <svg
                              className="svg-inline--fa fa-circle fa-w-16"
                              aria-hidden="true"
                              data-prefix="fas"
                              data-icon="circle"
                              role="img"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 512 512"
                              data-fa-i2svg=""
                            >
                              <path
                                fill="currentColor"
                                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                              ></path>
                            </svg>
                          </div>
                          <div className="tracking-date">
                            <i className="fa-solid fa-cart-arrow-down"></i>
                          </div>
                          <div className="tracking-content">Order Placed</div>
                        </div>
                        <div
                          className={`${
                            tracking?.order_status === "processing" ||
                            tracking?.order_status === "processed" ||
                            tracking?.order_status === "delivered" ||
                            tracking?.order_status === "out_for_delivery" ||
                            tracking?.order_status === "confirmed"
                              ? "tracking-item"
                              : "tracking-item-pending"
                          }`}
                        >
                          <div
                            className={`${
                              tracking?.order_status === "confirmed"
                                ? "tracking-icon status-current blinker"
                                : "tracking-icon status-intransit"
                            }`}
                          >
                            <svg
                              className="svg-inline--fa fa-circle fa-w-16"
                              aria-hidden="true"
                              data-prefix="fas"
                              data-icon="circle"
                              role="img"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 512 512"
                              data-fa-i2svg=""
                            >
                              <path
                                fill="currentColor"
                                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                              ></path>
                            </svg>
                          </div>
                          <div className="tracking-date">
                            <i className="fa-solid fa-boxes-packing"></i>
                          </div>
                          <div className="tracking-content">
                            Order Confirmed
                          </div>
                        </div>
                        <div
                          className={`${
                            tracking?.order_status === "processing" ||
                            tracking?.order_status === "processed" ||
                            tracking?.order_status === "out_for_delivery" ||
                            tracking?.order_status === "delivered"
                              ? "tracking-item"
                              : "tracking-item-pending"
                          }`}
                        >
                          <div
                            className={`${
                              tracking?.order_status === "processing"
                                ? "tracking-icon status-current blinker"
                                : "tracking-icon status-intransit"
                            }`}
                          >
                            <svg
                              className="svg-inline--fa fa-circle fa-w-16"
                              aria-hidden="true"
                              data-prefix="fas"
                              data-icon="circle"
                              role="img"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 512 512"
                              data-fa-i2svg=""
                            >
                              <path
                                fill="currentColor"
                                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                              ></path>
                            </svg>
                          </div>
                          <div className="tracking-date">
                            <i className="fa fa-dolly-flatbed"></i>
                          </div>
                          <div className="tracking-content">
                            Processing Order
                          </div>
                        </div>
                        <div
                          className={`${
                            tracking?.order_status === "out_for_delivery" ||
                            tracking?.order_status === "delivered"
                              ? "tracking-item"
                              : "tracking-item-pending"
                          }`}
                        >
                          <div
                            className={`${
                              tracking?.order_status === "out_for_delivery"
                                ? "tracking-icon status-current blinker"
                                : "tracking-icon status-intransit"
                            }`}
                          >
                            <svg
                              className="svg-inline--fa fa-circle fa-w-16"
                              aria-hidden="true"
                              data-prefix="fas"
                              data-icon="circle"
                              role="img"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 512 512"
                              data-fa-i2svg=""
                            >
                              <path
                                fill="currentColor"
                                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                              ></path>
                            </svg>
                          </div>
                          <div className="tracking-date">
                            <i className="fa-solid fa-truck-fast"></i>
                          </div>
                          <div className="tracking-content">
                            Order Dispatched
                            <span className="tracking-content-box">
                              {(tracking?.order_status === "out_for_delivery" ||
                                tracking?.order_status === "delivered") &&
                                tracking?.delivery_type ===
                                  "third_party_delivery" && (
                                  <>
                                    <span>
                                      Delivery Service Name :
                                      {tracking?.delivery_service_name}
                                    </span>
                                    <span>
                                      Tracking ID :
                                      {
                                        tracking?.third_party_delivery_tracking_id
                                      }
                                    </span>
                                  </>
                                )}
                            </span>
                          </div>
                        </div>
                        <div
                          className={`${
                            tracking?.order_status === "delivered"
                              ? "tracking-item"
                              : "tracking-item-pending"
                          }`}
                        >
                          <div
                            className={`${
                              tracking?.order_status === "delivered"
                                ? "tracking-icon status-current"
                                : "tracking-icon status-intransit"
                            }`}
                          >
                            {tracking?.order_status === "delivered" ? (
                              <img
                                src="/images/success-green-check.svg"
                                alt="check"
                                style={{ width: "18px" }}
                              />
                            ) : (
                              <svg
                                className="svg-inline--fa fa-circle fa-w-16"
                                aria-hidden="true"
                                data-prefix="fas"
                                data-icon="circle"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                data-fa-i2svg=""
                              >
                                <path
                                  fill="currentColor"
                                  d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                                ></path>
                              </svg>
                            )}
                          </div>
                          <div className="tracking-date">
                            <i className="fa-solid fa-box-open"></i>
                          </div>
                          <div className="tracking-content">Delivered</div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
